export class TokenExIframe {
    constructor(container, config) {
        if (!window.TokenEx) {
            throw new Error('TokenEx not provided');
        }

        this.iframe = new window.TokenEx.Iframe(container, config);
    }

    onLoad(callback) {
        this.iframe.on('load', callback);
    }

    onChange(callback) {
        this.iframe.on('change', callback);
    }

    onFocus(callback) {
        this.iframe.on('focus', callback);
    }

    onBlur(callback) {
        this.iframe.on('blur', callback);
    }

    onValidate(callback) {
        this.iframe.on('validate', callback);
    }

    onCardTypeChange(callback) {
        this.iframe.on('cardTypeChange', callback);
    }

    onCvvFocus(callback) {
        this.iframe.on('cvvFocus', callback);
    }

    onCvvBlur(callback) {
        this.iframe.on('cvvBlur', callback);
    }

    onTokenize(callback) {
        this.iframe.on('tokenize', callback);
    }

    onError(callback) {
        this.iframe.on('error', callback);
    }

    load() {
        this.iframe.load();
    }

    tokenize() {
        this.iframe.tokenize();
    }

    validate() {
        this.iframe.validate();
    }

    remove() {
        this.iframe.remove();
    }
}
